export default "__VITE_ASSET__CAn4pY0V__"